import { ThemeToggle } from '@/components/ui/theme-toggle';
import { Search, Menu } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

interface TopNavProps {
  onMenuClick: () => void;
}

export function TopNav({ onMenuClick }: TopNavProps) {
  return (
    <nav className="bg-card border-b border-border h-16 px-6 flex items-center justify-between sticky top-0 z-10">
      {/* Left: Menu toggle (mobile) */}
      <Button
        variant="ghost"
        size="icon"
        onClick={onMenuClick}
        className="lg:hidden"
        aria-label="Toggle navigation menu"
      >
        <Menu className="h-6 w-6" />
      </Button>

      {/* Center: Search */}
      <div className="flex-1 max-w-2xl mx-4">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input
            type="text"
            placeholder="Search tasks, projects, clients..."
            className="pl-10"
            aria-label="Search tasks, projects, and clients"
          />
        </div>
      </div>

      {/* Right: Theme toggle */}
      <div className="flex items-center gap-2">
        <ThemeToggle />
      </div>
    </nav>
  );
}
